export default __webpack_public_path__ + "static/IconClinica-7bd9c0ac2c616ffefcfc6688d482ee3d.svg";